import { Subscribe } from 'autogen/translation-keys/trans-website-shared-buttons';
import { Button, ButtonWithIcon } from 'components/Button';
import Icon from 'components/Icon';
import { eventCategoryToContext } from 'modules/tracking/GA4';
import { GA4Tracking } from 'modules/tracking/GA4/GA4Tracking';
import getProductListParams from 'modules/tracking/GA4/helpers/getProductListParams';
import { useTranslation } from 'react-i18next';
import type { IProductActionTrackingContext, ProductActionProps } from '../../shared/types';

function track(trackingInfo: IProductActionTrackingContext) {
    const context = eventCategoryToContext(trackingInfo.eventCategory);

    GA4Tracking({
        eventName: 'link_click',
        context,
        category: 'navigation',
        eventParams: [
            {
                param_name: 'link_type',
                param_value: 'internal'
            },
            { param_name: 'subscription_toggle', param_value: true },
            ...(context === 'product_list' ? getProductListParams() : [])
        ]
    });
}

export function SubscriptionProductButton({
    params,
    trackingInfo,
    children,
    ...restProps
}: ProductActionProps['Subscribe']) {
    const { t } = useTranslation();

    // TODO nkr NavigationLink
    return (
        <Button
            as="a"
            href={`${params.productNavigationLink.url}?subscription=true`}
            onClick={() => track(trackingInfo)}
            {...restProps}
        >
            {children || t(Subscribe)}
        </Button>
    );
}

export function SubscriptionProductButtonCompact({
    params,
    trackingInfo,
    ...restProps
}: ProductActionProps['Subscribe']) {
    // TODO nkr NavigationLink
    return (
        <ButtonWithIcon
            as="a"
            href={`${params.productNavigationLink.url}?subscription=true`}
            onClick={() => track(trackingInfo)}
            icon={<Icon type="ChevronRight" size={16} fill="white" />}
            {...restProps}
        />
    );
}

export default Object.assign(SubscriptionProductButton, {
    Compact: SubscriptionProductButtonCompact
});
